import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-details-items-keys-control',
  templateUrl: './details-items-keys-control.component.html',
  styleUrls: ['./details-items-keys-control.component.scss'],
})
export class DetailsItemsKeysControlComponent {
  @Input() amountKeys;
  @Input() amountControls;
  @Input() conservationState;
  @Input() photos = [];
  @Input() evaluationSurveyElementItemId;
}
